@if (!isProductCategory(product().category, productCategoryEnum.FERNWAERME) && !product().isAddressDetailsLinkOnlineNotPossible) {
  <h4 class="h5" data-test="product-card-tariff-list-item" [innerHtml]="tariffClasses() | tariffClassLineBreak"></h4>
} @else {
  @if (!showWaermeTariffClassesAsideOfIcon()) {
    <p
      class="mb-0 text--big"
      translate="newClient.productsSelection.noTariffSelection"
      [translateParams]="{ category: product().category | translateCategory }"
    ></p>
  }
  @if (showWaermeTariffClassesAsideOfIcon()) {
    <mwe-product-card-tariff-list-fernwaerme [tariffClasses]="tariffClasses()" />
  }
}
